import './ServicesSlide.css';
import React, { useEffect, useState } from 'react';
import { Box, Grid, List, ThemeProvider, Typography } from '@mui/material';
import ServiceCard from '../../ServiceCard/ServiceCard';
import { fetchServices } from '../../../backend/services';
import {Service} from '../../../../data_types';
import theme from '../../theme';

const ServicesSlide = () => {
    const [servicesPerRow, setServicessPerRow] = useState<number>(4);
    const [services, setServices] = useState<Service[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadServices = async () => {
            try {
                const data = await fetchServices();
                if (data.services && data.servicesPerRow) {
                    setServices(data.services);
                    setServicessPerRow(data.servicesPerRow); // Update state based on fetched data
                    document.documentElement.style.setProperty('--services-per-row', data.servicesPerRow.toString());
                } else {
                    setError('No service data available');
                }
            } catch (error) {
                setError('Failed to fetch services');
                console.error(error);
            }
        };
        loadServices();
    }, []);

    const groupServices = (services: Service[]): Service[][] => {
        const groupedServices: Service[][] = [];
        for (let i = 0; i < services.length; i += servicesPerRow) {
            // Use slice to get up to the next four items and push that as a new group
            groupedServices.push(services.slice(i, i + servicesPerRow));
        }
        return groupedServices;
    }

    return (
        <Box className='slide' id='services_slide'>
            <Grid className='slide_container' id='services_slide_container' justifyContent={'center'}>
                <Grid item className='slide_content' id='slide-title'>
                    Services
                </Grid>
                <Box className="grid-container" id="service-grid-container">
                    {error ? (
                        <Typography variant="h6" color="error" textAlign="center">
                            {error} {/* Displaying the error message */}
                        </Typography>
                    ) : (
                        groupServices(services).map((group, index) => (
                            <List key={index} className='component_container' disablePadding={true}>
                                {group.map(service => (
                                    <ThemeProvider theme={theme}>
                                        <ServiceCard key={service.id} id={service.id} serviceTitle={service.serviceTitle} imageUrl={service.imageUrl} videoUrl={service.videoUrl} serviceDescription={service.serviceDescription} servicesPerRow={servicesPerRow} hasVideoHover={service.hasVideoHover} />
                                    </ThemeProvider>
                                ))}
                            </List>
                        ))
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default ServicesSlide;
